export const iexCloudApiToken = "pk_a4720552fc2f4cc48386a0151bd458aa";

export const openExchangeRatesAppId = "3e1f291043bc4e55af295545d6952aaa";

export const cryptoCompareApiKey =
  "320ce3f8898c03907d22966345970745e36ed4e379848507897bc39a69f6dd2f";
